import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * Halil Aksu'nun iletişim sayfası.
 *
 * 15.09.2026'da istendi; adres talepte verildiği gibi
 * `/about/team/halil-aksu`. Sayfa bir kartvizit: isim, unvan ve verilen üç
 * kanal — e-posta ile her ülke için bir numara. Biyografi uydurulmadı; üç
 * eş-CEO hakkında sitenin söyledikleri Hakkımızda'da kalıyor, sayfa da oraya
 * geri bağlanıyor.
 */
export const teamHalilAksu: WrittenPage = {
  navLabel: 'Halil Aksu',
  title: 'Halil Aksu: Eş-CEO, Büyüme',
  description:
    'Digitopia Eş-CEO\'su Halil Aksu ile iletişim: halil@digitopia.ai, +1 302 444 2632 (ABD) veya +90 532 722 74 87 (Türkiye).',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Eş-CEO, Büyüme',
      headline: 'Halil Aksu',
      align: 'center',
      // 15.09.2026: fotoğraf yok — sayfaya zaten yüzünün olduğu bir kartvizitten
      // QR okutarak geliniyor, burası bir profil değil iletişim bilgisi.
      ctas: [
        // 28.09.2026: sadece bu sayfaya özel — Halil'in kendi Calendly linki.
        { label: 'Görüşme ayarlayın', href: 'https://calendly.com/halil-digitopia/30min' },
        { label: 'E-posta', href: 'mailto:halil@digitopia.ai' },
        { label: 'LinkedIn', href: 'https://www.linkedin.com/in/halilaksu/' },
        // 17.09.2026: telefona doğrudan kaydetmek için vCard. Dosya
        // `public/vcf/` içinde, sayfanın slug'ıyla aynı adda.
        { label: 'Rehbere kaydet', href: '/vcf/halil-aksu.vcf' },
      ],
    },
    {
      kind: 'features',
      heading: 'İletişim',
      columns: 3,
      items: [
        {
          title: 'halil@digitopia.ai',
          note: 'E-posta',
          href: 'mailto:halil@digitopia.ai',
        },
        {
          title: '+1 302 444 2632',
          note: 'ABD',
          href: 'tel:+13024442632',
        },
        {
          title: '+90 532 722 74 87',
          note: 'Türkiye',
          href: 'tel:+905327227487',
        },
      ],
      footnote: 'Digitopia New York, Londra ve İstanbul\'dan çalışıyor.',
    },
    {
      kind: 'cta',
      heading: 'Kişi yerine firmayla mı başlamak istersiniz?',
      sub: 'İletişim formu tüm ekibe ulaşır; Hakkımızda ise birlikte çalışacağınız diğer isimleri anlatır.',
      tone: 'band',
      ctas: [
        { label: 'Digitopia ile iletişime geçin', href: LINKS.contact },
        { label: 'Hakkımızda', href: LINKS.about },
      ],
    },
  ],
}
